import validation from './validation';
import app from './app';
import catalog from './catalog';
import steps from './steps';
import recap from './recap';

const en = {
	validation,
	app,
	catalog,
	steps,
	recap,
};

export default en;
